/**
 * NAO checkout — validación de campos del formulario.
 * `validateField` es autónomo (solo depende de `validations` y del DOM),
 * por eso no necesita el contexto compartido.
 */

// Los mensajes van en frase, no en mayúsculas: el formulario corrige, no grita.
export const validations = {

    // Un solo campo de nombre. El backend parte esta cadena por el primer
    // espacio para separar nombre y apellido, así que se pide el apellido de
    // verdad — sin él la guía de envío sale incompleta.
    full_name: value => {
        const limpio = (value || '').trim();
        if (!limpio) return 'Escribe tu nombre y apellido';
        return limpio.split(/\s+/).length >= 2 ? '' : 'Falta el apellido';
    },

    phone: value =>
        /^3\d{9}$/.test(value)
            ? ''
            : 'Celular de 10 dígitos, empezando por 3',

    whatsapp_phone: value =>
        /^3\d{9}$/.test(value)
            ? ''
            : 'Celular de 10 dígitos, empezando por 3',

    email: value =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
            ? ''
            : 'Revisa el correo',

    address: value =>
        value ? '' : 'Escribe tu dirección',

    province: value =>
        value ? '' : 'Elige tu departamento',

    city: value =>
        value ? '' : 'Elige tu ciudad'
};

export function validateField(input) {

    const errorSpan = input
        .closest('.nao-form-group')
        ?.querySelector('.nao-error-msg');

    const wrapperEl =
        input.closest('.nao-input-wrapper');

    const validator = validations[input.name];

    // Un campo opcional y vacío no es un error. Esto es lo que permite que
    // `complement` sea opcional siempre y que el correo lo sea solo en
    // contraentrega (ahí el JS le quita el `required`, ver applySelection).
    const opcionalYVacio = !input.required && !input.value.trim();

    const error = validator && !opcionalYVacio
        ? validator(input.value)
        : '';

    if (error) {

        if (wrapperEl) {
            wrapperEl.style.borderColor =
                'var(--nao-error-red)';
        }

        if (errorSpan) {
            errorSpan.textContent = error;
        }

        return false;
    }

    if (wrapperEl) {
        wrapperEl.style.borderColor =
            'var(--nao-gray-border)';
    }

    if (errorSpan) {
        errorSpan.textContent = '';
    }

    return true;
}
